﻿import React from 'react';
import {ActionsMenuOpenButton} from "./ActionsMenuOpenButton";
import {IconButtonProps} from "@mui/material";
import {styled} from "@mui/styles";

const Root = styled(ActionsMenuOpenButton)(() => ({
  position: 'absolute',
  top: '38%',
  right: '0.5em',
}));

type ActionsMenuOpenButtonAbsoluteProps = IconButtonProps

/**
 * ActionsMenuOpenButton styled absolutely with a change in color. Common usages include: GridCardAction, SpaceUsageCard and PaymentType
 * @param props props to be passed through to the internal ActionsMenuOpenButton
 * @constructor
 */
const ActionsMenuOpenButtonAbsolute = (props: ActionsMenuOpenButtonAbsoluteProps) => {
  return <Root {...props}/>
}

export { ActionsMenuOpenButtonAbsolute };
